export default (operation) => (item) => {
  const fieldValue = getFieldValue(operation, item)
  const operatedValue = getOperatedValue(fieldValue, operation)

  return {
    quote: item.itemId,
    proposalPrice: operatedValue
  }
}

const getFieldValue = ({ fieldName }, item) => {
  switch (fieldName) {
    case 'CUSTO':
      return item.quoted.price
    case 'ESTIMADO':
      return item.itemInfo.estimatedPrice
    case 'MÁXIMO':
      return item.quoted.cmedPrice
    default:
      return item.quoted.price
  }
}

const getOperatedValue = (fieldValue, { operator, value, valueType }) => {
  let stringOperation = fieldValue
  const currencyValue = convertCurrencyToNumber(value)

  switch (valueType) {
    case 'R$':
      stringOperation += `${operator}${currencyValue}`
      break
    case '%':
      const perc = getPercentualValue(fieldValue, currencyValue)
      stringOperation += `${operator}${perc}`
      break
    default:
      break
  }
  const calculated = addbits(stringOperation)

  return calculated
}

function getPercentualValue (fieldValue, value) {
  return fieldValue * (value / 100)
}

function addbits (s) {
  let total = 0
  const a = s.match(/[+-]*(\.\d+|\d+(\.\d+)?)/g) || []

  while (a.length) {
    total += parseFloat(a.shift())
  }
  return total
}

function convertCurrencyToNumber (v) {
  return v && Number(v
    .toString()
    .replace('.', '')
    .replace(',', '.'))
}



// WEBPACK FOOTER //
// ./src/view/item-pricing/helpers/CalculateSaleFilter.js